/**
 * Field Routes
 */
import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Location } from 'Util/Location';

// async components
import {
  AsyncFieldDetailWorkLogComponent,
  AsyncFieldMinutesOfMeetingsDetail,
  AsyncFieldMinutesOfMeetingsCreate,
  AsyncFieldMinutesOfMeetingsUpdate,
  AsyncFieldDetail,
} from 'Components/AsyncComponent/AsyncComponent';

const Field = () => {
  const location = useLocation();

  return (
    <div className="content-wrapper">
      {location.pathname === '/admin/field' && <Navigate to={`work-logs`} replace />}
      <Routes>
        <Route path={`minutes-of-meetings/:detailId`} element={<AsyncFieldMinutesOfMeetingsDetail />} />
        <Route path={`minutes-of-meetings/create`} element={<AsyncFieldMinutesOfMeetingsCreate />} />
        <Route path={`minutes-of-meetings/:detailId/update`} element={<AsyncFieldMinutesOfMeetingsUpdate />} />
        {/* <Route path="contract/detail/:detailId" element={<AsyncFieldContractDetail />} />
        <Route path="contract/create" element={<AsyncFieldContractCreate />} /> */}
        <Route path="worklog/:logId" element={<AsyncFieldDetailWorkLogComponent />} />
        <Route path=":type" element={<AsyncFieldDetail />} />
      </Routes>
    </div>
  );
};

export default Location(Field);
